import gql from 'graphql-tag'
import { dayOrder } from '../fragments'

const createDateOrderMutation = gql`
mutation CA_Mutation_createDateOrderValues($required: DateOrderValuesRequired!, $fields: DateOrderValuesInput) {
	cashAssist {
		createDateOrderValues(required: $required, fields: $fields) {
			...dayOrder
		}
	}
}
${dayOrder}`

export default createDateOrderMutation
